import { CustHomeGrid } from "../grids/CustHomeGrid"

export default function CustomerHome() {
    return(
        <>
          <CustHomeGrid />
        </>
    )
}